// Storage
import { uploadFile, deleteFile, refFromUrl, getDownloadURLFromRef } from '@/services/storage'
// Mixins
import uiMixin from '@/mixins/uiMixin'
// Components
import FileUploader from '../FileUploader'
// utils
const uniqid = require('uniqid')

export default {
  name: 'PreviewImageUploader',
  model: {
    prop: 'imageUrl',
    event: 'imageUploaded'
  },
  components: { FileUploader },
  mixins: [uiMixin],
  props: {
    enabledResizer: {
      type: Boolean,
      default: true
    },
    imageUrl: {
      type: String,
      default: ''
    },
    dimensionBox: {
      type: Object,
      default() {
        return {
          width: 150,
          height: 150
        }
      }
    },
    labelBox: {
      type: String,
      default: 'Sin imagen'
    },
    labelInfo: {
      type: String,
      default: ''
    },
    maxSizeImage: {
      type: Object,
      default() {
        return {
          width: 1280,
          height: 720
        }
      }
    },
    storagePath: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentFile: {
        url: null,
        ref: null
      },
      userDoesAnAction: false,
      processingRequest: false
    }
  },
  computed: {
    /**
     * If it exists an image the button to upload is disabled
     */
    isThereAnImage() {
      let isThere = false

      if (this.currentFile.url || (this.imageUrl && this.userDoesAnAction === false)) {
        isThere = true
      }
      return isThere
    },
    /**
     * Get the URL to preview the image
     */
    getCurrentImgUrl() {
      let currentPreview = null

      if (this.currentFile.url) {
        currentPreview = this.currentFile.url
      } else if (this.imageUrl && this.userDoesAnAction === false) {
        currentPreview = this.imageUrl
      }
      return currentPreview
    },
    /**
     * Get the custom styles to "box"
     */
    getStyleBox() {
      let style = ''

      if (this.getCurrentImgUrl) {
        style += `background-image:url(${this.getCurrentImgUrl});`
      }

      if (this.dimensionBox && this.dimensionBox.width && this.dimensionBox.height) {
        style += `width:${this.dimensionBox.width}px;height:${this.dimensionBox.height}px;`
      }

      return style
    }
  },
  methods: {
    /**
     * handle the current button action
     */
    handleUpdatePreviewImage() {
      if (this.isThereAnImage) {
        this.handleActionOnPreviewImage(true)
      } else {
        this.$refs.fileUploader.handleClick()
      }
    },
    /**
     * Handle remove preview image
     */
    handleRemovePreviewImage() {
      this.handleActionOnPreviewImage(false)
    },
    /**
     * Get the files that the user wants to upload
     *
     * @param {string} error - error to show
     */
    handleError(error) {
      this.modifyAppAlert({
        type: 'error',
        text: error.message,
        visible: true
      })
    },
    /**
     * Get the files that the user wants to upload
     *
     * @param {Boolean} loading - there are some files in processing?
     */
    handleProcessingFiles(loading) {
      this.processingRequest = loading
    },
    /**
     * Get the files that the user wants to upload
     *
     * @param {Array} files - files array to upload
     */
    async handleUploadFiles(files) {
      const file = files[0]
      // The user make an action
      this.userDoesAnAction = true
      // upload image to server
      this.uploadImageToServer(file)
    },
    /**
     * Handle preview image
     *
     * @param {Boolean} update - open file dialog
     */
    async handleActionOnPreviewImage(update = false) {
      this.modifyAppAlert({
        actionButtonFn: async () => {
          // show loading
          this.processingRequest = true

          // Remove from server
          await this.delFileInServer(this.getCurrentImgUrl)
          // Set user's action
          this.userDoesAnAction = true
          // Remove from local
          this.currentFile.ref = null
          this.currentFile.url = null

          // Emit the new value (empty)
          this.$emit('imageUploaded', '')

          this.processingRequest = false

          // Re-open dialog files
          if (update) {
            this.$refs.fileUploader.handleClick()
          }
        },
        actionButtonText: update ? 'Cambiar' : 'Borrar',
        text: update ? '¿Desea cambiar la imagen?' : '¿Desea borrar la imagen?',
        type: 'warning',
        visible: true
      })
    },
    /**
     * Upload files to server (Firebase)
     *
     * @param {Object} file - file BLOB
     */
    async uploadImageToServer(file) {
      try {
        // Show loading
        this.processingRequest = true

        // Upload file
        const fileName = uniqid()
        const path = this.storagePath || uniqid()

        // Get the reference from firebase
        this.currentFile.ref = await uploadFile(file, `${path}/${fileName}`)
        this.currentFile.url = await getDownloadURLFromRef(this.currentFile.ref)

        // Hide loading
        this.processingRequest = false

        // Emit the new value
        this.$emit('imageUploaded', this.currentFile.url)
      } catch (error) {
        this.handleError(error.message)
      }
    },
    /**
     * Delete file in server (Firebase)
     *
     * @param {string} url - public URL
     */
    async delFileInServer(url) {
      try {
        const ref = await refFromUrl(url)
        deleteFile(ref)
      } catch (error) {
        this.handleError(error.message)
      }
    }
  }
}
